module.exports = __webpack_public_path__ + "media/images/icon/rocket-f48933b47f0d5a189aa2316893a92402.svg";